import Me from '@images/me/profile.jpg';

export const me = {
    id: "ez7mz",
    displayName: "Hamzaaa",
    displayRole: "Data Scientist @Oracle",
    displayDescription: "A mind wired for AI, a heart driven by curiosity, and a passion for transforming data into impact. Exploring patterns, predicting possibilities, and engineering intelligence—one model at a time.",
    socialLinks: {
        github: "https://github.com/oo7mza",
        linkedin: "https://www.linkedin.com/in/oo7mza/",
        twitter: "https://twitter.com/",
        instagram: "https://www.instagram.com/oo7mza/",
        email: "mailto:hmesrar48@gmail.com",
        whatsapp: "https://api.whatsapp.com/send?phone=0633099608&text=Hello, from your portfolio, I would like to chit-chat with you."
    },
    socialUsernames: {
        github: "oo7mza",
        linkedin: "in/oo7mza",
        twitter: "@oo7mza",
        instagram: "@oo7mza",
        email: "hmesrar48@gmail.com",
        whatsapp: "+212 665-949864"
    },
    image: Me
};